/**
 * @param {ReduxState} state - The Redux state.
 * @returns {StatsLeadersState} The Stats Leaders state.
 */
export const statsLeadersSelector = state => state.statspro.statsLeaders;